import { render, staticRenderFns } from "./ViberCampaignsListRoute.vue?vue&type=template&id=13e220a2&scoped=true&"
import script from "./ViberCampaignsListRoute.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignsListRoute.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignsListRoute.vue?vue&type=style&index=0&id=13e220a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e220a2",
  null
  
)

export default component.exports